import {
  isAgencyAdmin,
  isAgencyUser,
  isRolePlatformAdmin,
  token,
} from "../../../modules/auth";
import { isCompanyAdmin, isCompanyUser } from "../../../modules/permissions";
import { fetchHotelGroup, fetchSnapshotReport } from "../../../redux/actions";
import { connect } from "react-redux";
import React, { useState, useEffect } from "react";
import PreferredProgrammeOverrideForm from "../../../Components/PreferredProgrammes/PreferredProgrammeOverrideForm";
import { withRouter } from "react-router";
import NotFound from "../../NotFound";
import Loading from "../../../Components/Loading";
let PreferredProgrammeEditContainer = ({
  groupId,
  hotelGroup,
  fetchHotelGroup,
  token,
  match,
  isCorporate = false,
  hotelGroupNotFound,
  isFetchingHotelGroup,
}) => {
  const [loading, setLoading] = useState(false);
  const [programme, setProgramme] = useState(null);
  useEffect(() => {
    fetchHotelGroup(groupId, token, match.params.programme, true);
  }, []);

  useEffect(() => {
    if (hotelGroup) {
      setProgramme(
        hotelGroup.programmes.find(
          p => parseInt(p.id) === parseInt(match.params.programme)
        )
      );
    }
  }, [hotelGroup]);

  if (!hotelGroup || isFetchingHotelGroup) {
    return <Loading />;
  }
  if (hotelGroupNotFound) {
    return <NotFound />;
  }
  const isCustomGroup = hotelGroup?.groupType?.code === "CHG";
  return (
    <div>
      <div className="border-b border-gray-200 sm:rounded-lg bg-white p-5">
        <h1 className={"py-3"}>
          Edit{" "}
          {isCustomGroup
            ? "Custom Group Overrides"
            : "Group Overrides"}{" "}
          {!isCustomGroup ? "For " + hotelGroup.name : null}
        </h1>
        {programme ? <p>This custom group is in <strong>{programme.company ? programme.company.name : programme.agency.name}'s</strong> Preferred Programme</p> : null}

        <PreferredProgrammeOverrideForm
          hotelGroup={hotelGroup}
          token={token}
          isCustomGroup={isCustomGroup}
          programme={programme}
          isCorporate={isCorporate}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...state.hotelGroup,
    ...state.snapshotReport,
    token: token(state),
    isAgencyAdmin: isAgencyAdmin(state),
    isAgencyUser: isAgencyUser(state),
    isCompanyAdmin: isCompanyAdmin(state.auth),
    isCompanyUser: isCompanyUser(state.auth),
    isRolePlatformAdmin: isRolePlatformAdmin(state),
    groupId: props.match.params.id,
  };
};

const mapDispatchToProps = {
  fetchHotelGroup,
  fetchSnapshotReport,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(PreferredProgrammeEditContainer)
);
